import { PHONE_DISPLAY, PHONE_TEL } from '../../../lib/businessInfo';

const categories = [
  {
    title: 'Running Vehicles',
    items: [
      'Cars, trucks, and SUVs in good condition',
      'High-mileage vehicles still running strong',
      'Vehicles with minor cosmetic issues',
      'Fleet vehicles and commercial trucks'
    ]
  },
  {
    title: 'Non-Running Vehicles',
    items: [
      'Mechanical issues or engine problems',
      'Transmission failures',
      'Vehicles that won\'t start',
      'Project cars and barn finds'
    ]
  },
  {
    title: 'Damaged Vehicles',
    items: [
      'Accident-damaged vehicles',
      'Hail or weather damage',
      'Flood-damaged vehicles',
      'Salvage title vehicles'
    ]
  },
  {
    title: 'Special Situations',
    items: [
      'Inherited vehicles',
      'Divorce settlements',
      'Estate sales',
      'Repossessions and liens'
    ]
  }
];

export default function WhatWeBuy() {
  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What We Buy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We buy all makes, models, and conditions. If you have a vehicle to sell, we're interested.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {categories.map((category, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4">{category.title}</h3>
              <ul className="space-y-3 list-none p-0">
                {category.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-teal-600 text-lg" aria-hidden="true"></i>
                    </span>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 border border-teal-200 rounded-xl p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Not Sure If We'll Buy Your Vehicle?
          </h3>
          <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
            Give us a call! We buy vehicles in situations most dealers won't touch. Even if your car has issues, we'll make you a fair offer.
          </p>
          <a
            href={`tel:${PHONE_TEL}`}
            className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-line text-lg" aria-hidden="true"></i>
            </span>
            {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </div>
  );
}
